import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const alertVariants = cva(
  'relative w-full rounded-lg p-4',
  {
    variants: {
      variant: {
        info: 'bg-blue-50 text-blue-900 dark:bg-blue-900/20 dark:text-blue-100',
        success: 'bg-green-50 text-green-900 dark:bg-green-900/20 dark:text-green-100',
        warning: 'bg-yellow-50 text-yellow-900 dark:bg-yellow-900/20 dark:text-yellow-100',
        destructive: 'bg-red-50 text-red-900 dark:bg-red-900/20 dark:text-red-100',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
);

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {
  title?: string;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant, title, children, ...props }, ref) => (
    <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
      {title && <h5 className="mb-1 font-medium leading-none tracking-tight">{title}</h5>}
      <div className="text-sm [&_p]:leading-relaxed">{children}</div>
    </div>
  ),
);
Alert.displayName = 'Alert';

export { Alert, alertVariants };
